import axios from "axios"
import endpoints from "../endpoint"

export const savedFcmToken = async (token) => {

    try {
        const response = await axios.post(endpoints.serverBaseUrl + "api/fcmtoken", { token: token });
        console.log(response)
    } catch (error) {
        console.log(error)
    }


    console.log("inside the function", token)
}